import { render, staticRenderFns } from "./ImpersonateIndicator.vue?vue&type=template&id=4abc2e9b&scoped=true&"
import script from "./ImpersonateIndicator.vue?vue&type=script&lang=ts&"
export * from "./ImpersonateIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonateIndicator.vue?vue&type=style&index=0&id=4abc2e9b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc2e9b",
  null
  
)

export default component.exports